module.exports = __webpack_public_path__ + "static/media/realtors-icon-7.abcec53d.svg";